import './hot';
import 'vant/es/notify/style'
import 'vant/es/toast/style'

import { createApp } from 'vue';
import { createPinia } from 'pinia'
import App from './App.vue';
import { appConfig } from './appConfig';
import { stat } from '@/common/util/statManager';
import { ConfigProvider } from 'vant';
import { getQueryParam } from './common/util/getUrlParam';
import { setupAppLocale, t } from './i18n';
import { getWindowInfo } from './getWindowInfo';
import { createAppRouter } from './router/router';

const query = (key: string) => {
    const paramValue = getQueryParam(key);
    // 仅当 URL 参数存在时使用并写入 sessionStorage，
    // 否则不回退到 sessionStorage 的历史值，保证未传值时使用默认语言。
    if (paramValue && paramValue !== '') {
        window.sessionStorage.setItem(`query:${key}`, paramValue);
        return paramValue;
    }
    return '';
};

const urlIsShowUpload = !!Number(getQueryParam('isShowUpload'));
const urlIsNotAuthModal = !!Number(getQueryParam('isNotAuthModal'));
const urlLanguage = query('language') || query('locale');
const urlRegion = query('region');
urlIsShowUpload === false ? '' : window.isShowUpload = urlIsShowUpload;
urlIsNotAuthModal === false ? '' : window.isNotAuthModal = urlIsNotAuthModal;
console.log(urlRegion, 'urlRegion');
setupAppLocale(urlLanguage);
document.title = t('HelpFeedback');
getWindowInfo();

async function render() {
    const pinia = createPinia();
    const app = createApp(App).use(pinia).use(ConfigProvider);
    (process.env.NODE_ENV === 'development') && console.table({
        title: '模版项目配置',
        version: '1.0.0',
        appConfig,
    });

    // 埋点相关逻辑
    const router = createAppRouter();
    stat.setupPageEnterAndPageLeave(router);

    app.use(router);
    app.mount('#app');
    return app;
}

render();

